import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import "jspdf-autotable";
import "./ImmigrationFormView.css";

const ImmigrationFormView = () => {
  const location = useLocation();
  const { fullFormData } = location?.state || {};
  const navigate = useNavigate();
  console.log("Form Data:", fullFormData);

  // Format date to readable format
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    } catch (error) {
      return "N/A";
    }
  };

  // Format boolean/yes-no responses
  const formatResponse = (value) => {
    if (value === undefined || value === null || value === "") return "N/A";
    if (typeof value === "boolean") return value ? "Yes" : "No";
    return value.toString();
  };

  // Helper function to render education history
  const renderEducationHistory = (educationHistory, personType) => {
    if (!educationHistory || educationHistory.length === 0) return null;

    return (
      <div className="col-12 mb-4">
        <div className="card shadow-sm">
          <div
            className="card-header"
            style={{ backgroundColor: "#ff9c00", color: "white" }}
          >
            <h5 className="mb-0">
              <i className="fas fa-graduation-cap me-2"></i>
              {personType} Education History
            </h5>
          </div>
          <div className="card-body">
            {educationHistory.map((edu, index) => (
              <div key={index} className="mb-4">
                <h6 className="text-primary mb-3">Education #{index + 1}</h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="info-item">
                      <span className="label">Level of Education:</span>
                      <span className="value">
                        {formatResponse(edu.levelOfEducation)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">Field of Study:</span>
                      <span className="value">
                        {formatResponse(edu.studyName)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">From Date:</span>
                      <span className="value">{formatDate(edu.fromDate)}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">To Date:</span>
                      <span className="value">{formatDate(edu.toDate)}</span>
                    </div>
                    <div className="info-item">
                      <span className="label">City of Education:</span>
                      <span className="value">
                        {formatResponse(edu.cityOfEducation)}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-item">
                      <span className="label">Country of Education:</span>
                      <span className="value">
                        {formatResponse(edu.countryOfEducation)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">Institution Name:</span>
                      <span className="value">
                        {formatResponse(edu.nameOfInstitution)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">Institution Address:</span>
                      <span className="value">
                        {formatResponse(edu.addressOfInstitution)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">DLI Number:</span>
                      <span className="value">
                        {formatResponse(edu.designatedLearningInstituteNo)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">Campus City:</span>
                      <span className="value">
                        {formatResponse(edu.cityOfCampusAttended)}
                      </span>
                    </div>
                  </div>
                </div>
                {index < educationHistory.length - 1 && <hr className="my-3" />}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // Helper function to render work history
  const renderWorkHistory = (workHistory, personType) => {
    if (!workHistory || workHistory.length === 0) return null;

    return (
      <div className="col-12 mb-4">
        <div className="card shadow-sm">
          <div
            className="card-header"
            style={{ backgroundColor: "#ff9c00", color: "white" }}
          >
            <h5 className="mb-0">
              <i className="fas fa-briefcase me-2"></i>
              {personType} Work History
            </h5>
          </div>
          <div className="card-body">
            {workHistory.map((work, index) => (
              <div key={index} className="mb-4">
                <h6 className="text-primary mb-3">
                  Work Experience #{index + 1}
                </h6>
                <div className="row">
                  <div className="col-md-6">
                    <div className="info-item">
                      <span className="label">Job Title:</span>
                      <span className="value">
                        {formatResponse(work.jobTitle)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">From Date:</span>
                      <span className="value">
                        {formatDate(work.jobFromDate)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">To Date:</span>
                      <span className="value">
                        {formatDate(work.jobToDate)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">Employment Type:</span>
                      <span className="value">
                        {work.fullTimeOrPartTime === "full"
                          ? "Full Time"
                          : "Part Time"}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="info-item">
                      <span className="label">Hours/Week:</span>
                      <span className="value">
                        {formatResponse(work.hoursPerWeek)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">NOC Code:</span>
                      <span className="value">
                        {formatResponse(work.NOCcode)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">Company Name:</span>
                      <span className="value">
                        {formatResponse(work.companyName)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">Company Address:</span>
                      <span className="value">
                        {formatResponse(work.companyAddressWithPostalCode)}
                      </span>
                    </div>
                  </div>
                </div>
                {index < workHistory.length - 1 && <hr className="my-3" />}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  // Helper function to render language test details
  const renderLanguageTest = (personData, personType) => {
    if (!personData || personData.languageTestTaken !== "Yes") return null;

    return (
      <div className="col-12 mb-4">
        <div className="card shadow-sm">
          <div
            className="card-header"
            style={{ backgroundColor: "#ff9c00", color: "white" }}
          >
            <h5 className="mb-0">
              <i className="fas fa-language me-2"></i>
              {personType} Language Test Details
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="info-item">
                  <span className="label">Test Type:</span>
                  <span className="value">
                    {formatResponse(personData.typeOfTest)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Test Version:</span>
                  <span className="value">
                    {formatResponse(personData.languageTestVersion)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Date of Test:</span>
                  <span className="value">
                    {formatDate(personData.dateOfTest)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Date of Result:</span>
                  <span className="value">
                    {formatDate(personData.dateOfTestResult)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Certificate No:</span>
                  <span className="value">
                    {formatResponse(personData.languageTestCertificateNo)}
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                {personData.typeOfTest === "IELTS" && (
                  <div className="info-item">
                    <span className="label">IELTS Certificate No:</span>
                    <span className="value">
                      {formatResponse(personData.IELTScertificateNo)}
                    </span>
                  </div>
                )}
                {personData.typeOfTest === "CELPIP" && (
                  <>
                    <div className="info-item">
                      <span className="label">CELPIP Reg No:</span>
                      <span className="value">
                        {formatResponse(personData.CELPIPregNo)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">CELPIP PIN No:</span>
                      <span className="value">
                        {formatResponse(personData.CELPIPpinNo)}
                      </span>
                    </div>
                  </>
                )}
                {personData.typeOfTest === "PTE" && (
                  <>
                    <div className="info-item">
                      <span className="label">PTE Report Code:</span>
                      <span className="value">
                        {formatResponse(personData.PTEreportCode)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">PTE Test Taker ID:</span>
                      <span className="value">
                        {formatResponse(personData.PTEtestTakerId)}
                      </span>
                    </div>
                    <div className="info-item">
                      <span className="label">PTE Reg ID:</span>
                      <span className="value">
                        {formatResponse(personData.PTEregId)}
                      </span>
                    </div>
                  </>
                )}
                <div className="info-item">
                  <span className="label">Speaking:</span>
                  <span className="value">
                    {formatResponse(personData.speaking)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Reading:</span>
                  <span className="value">
                    {formatResponse(personData.reading)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Listening:</span>
                  <span className="value">
                    {formatResponse(personData.listening)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Writing:</span>
                  <span className="value">
                    {formatResponse(personData.writing)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">French Test Taken:</span>
                  <span className="value">
                    {formatResponse(personData.takenAnApprovedTestForFrench)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Helper function to render ECA details
  const renderECA = (personData, personType) => {
    if (!personData || !personData.ECAOrganization) return null;

    return (
      <div className="col-12 mb-4">
        <div className="card shadow-sm">
          <div
            className="card-header"
            style={{ backgroundColor: "#ff9c00", color: "white" }}
          >
            <h5 className="mb-0">
              <i className="fas fa-certificate me-2"></i>
              {personType} ECA Details
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="info-item">
                  <span className="label">Organization:</span>
                  <span className="value">
                    {formatResponse(personData.ECAOrganization)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Report Issue Date:</span>
                  <span className="value">
                    {formatDate(personData.dateECAreportIssued)}
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-item">
                  <span className="label">Certificate No:</span>
                  <span className="value">
                    {formatResponse(personData.ECAcertificateNo)}
                  </span>
                </div>
                <div className="info-item">
                  <span className="label">Equivalency:</span>
                  <span className="value">
                    {formatResponse(personData.ECAequivalency)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Helper function to render relatives in Canada
  const renderRelativesInCanada = (personData) => {
    if (!personData || personData.relativesInCanada !== "Yes") return null;

    return (
      <div className="col-12 mb-4">
        <div className="card shadow-sm">
          <div
            className="card-header"
            style={{ backgroundColor: "#ff9c00", color: "white" }}
          >
            <h5 className="mb-0">
              <i className="fas fa-users me-2"></i>
              Relatives in Canada
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <div className="info-item">
                  <span className="label">Has Relatives in Canada:</span>
                  <span className="value">
                    {formatResponse(personData.relativesInCanada)}
                  </span>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-item">
                  <span className="label">Resident Status:</span>
                  <span className="value">
                    {formatResponse(personData.relativesInCanadaResidentWith)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Helper function to render declarations for a person
  const renderDeclarations = (personData, personType = "Primary Applicant") => {
    const declarations = [
      {
        question: "Has applicant been refused visa or permit?",
        answer:
          personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry,
        remarks:
          personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks,
      },
      {
        question: "Has applicant committed any criminal offence?",
        answer:
          personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry,
        remarks:
          personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks,
      },
      {
        question: "Has applicant been detained or incarcerated?",
        answer: personData?.HasApplicantBeenDetainedIncarceratedorPutinJail,
        remarks:
          personData?.HasApplicantBeenDetainedIncarceratedorPutinJailRemarks,
      },
      {
        question: "Has applicant been associated with armed groups?",
        answer:
          personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives,
        remarks:
          personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks,
      },
      {
        question: "Has applicant been involved in war crimes?",
        answer:
          personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity,
        remarks:
          personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks,
      },
      {
        question: "Has applicant been member of criminal organization?",
        answer:
          personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity,
        remarks:
          personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks,
      },
      {
        question: "Has applicant had serious disease or disorder?",
        answer:
          personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder,
        remarks:
          personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks,
      },
      {
        question: "Has applicant used/planned armed struggle?",
        answer:
          personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectives,
        remarks:
          personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousOrSocialObjectivesRemarks,
      },
      {
        question: "Has applicant been convicted in Canada without pardon?",
        answer:
          personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada,
        remarks:
          personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks,
      },
    ];

    // Filter out declarations where both answer and remarks are empty
    const validDeclarations = declarations?.filter(
      (decl) => decl.answer || (decl.remarks && decl.remarks.trim() !== ""),
    );

    if (validDeclarations.length === 0) return null;

    return (
      <div className="col-12 mb-4">
        <div className="card shadow-sm">
          <div
            className="card-header"
            style={{ backgroundColor: "#ff9c00", color: "white" }}
          >
            <h5 className="mb-0">
              <i className="fas fa-file-contract me-2"></i>
              {personType} Declarations
            </h5>
          </div>
          <div className="card-body">
            <div className="row">
              {validDeclarations.map((decl, index) => (
                <div className="col-md-6 mb-3" key={index}>
                  <div className="info-item declaration-item">
                    <span className="label">{decl.question}</span>
                    <span
                      className={`value ${
                        decl.answer === "Yes" ? "text-danger" : "text-success"
                      }`}
                    >
                      {formatResponse(decl.answer)}
                    </span>
                  </div>
                  {decl.remarks && decl.remarks.trim() !== "" && (
                    <div className="info-item">
                      <span className="label">Remarks:</span>
                      <span className="value text-muted">{decl.remarks}</span>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Download PDF function
  // const downloadPDF = () => {
  //   const doc = new jsPDF();

  //   // Title
  //   doc.setFontSize(20);
  //   doc.setTextColor(255, 156, 0); // #ff9c00
  //   doc.text("IMMIGRATION APPLICATION FORM", 105, 15, null, null, "center");

  //   doc.setFontSize(10);
  //   doc.setTextColor(0, 0, 0);
  //   doc.text(`Application ID: ${fullFormData?._id || "N/A"}`, 15, 25);
  //   doc.text(`Date: ${new Date().toLocaleDateString()}`, 180, 25);

  //   let yPos = 35;
  //   const leftMargin = 15;
  //   const rightMargin = 195;
  //   const pageHeight = 280;

  //   // Helper function to add text with word wrap
  //   const addTextWithWrap = (text, x, y, maxWidth) => {
  //     if (!text || text === "N/A") return 0;
  //     const lines = doc.splitTextToSize(text.toString(), maxWidth);
  //     doc.text(lines, x, y);
  //     return lines.length;
  //   };

  //   // Helper function to check page break
  //   const checkPageBreak = (requiredSpace = 10) => {
  //     if (yPos + requiredSpace > pageHeight) {
  //       doc.addPage();
  //       yPos = 20;
  //       return true;
  //     }
  //     return false;
  //   };

  //   // Helper function to add section
  //   const addSection = (title, contentLines) => {
  //     checkPageBreak(20);
  //     doc.setFontSize(14);
  //     doc.setTextColor(255, 156, 0);
  //     doc.text(title, leftMargin, yPos);
  //     yPos += 8;

  //     doc.setDrawColor(255, 156, 0);
  //     doc.line(leftMargin, yPos, rightMargin, yPos);
  //     yPos += 10;

  //     doc.setFontSize(10);
  //     doc.setTextColor(0, 0, 0);

  //     contentLines.forEach(({ label, value }) => {
  //       if (!value || value === "N/A") return;

  //       checkPageBreak(8);

  //       doc.setFont("helvetica", "bold");
  //       doc.text(`${label}:`, leftMargin, yPos);

  //       doc.setFont("helvetica", "normal");
  //       const valueText = value || "N/A";
  //       const lines = addTextWithWrap(
  //         valueText,
  //         leftMargin + 70,
  //         yPos,
  //         rightMargin - leftMargin - 70,
  //       );

  //       yPos += lines * 7 + 2;
  //     });

  //     yPos += 5;
  //   };

  //   // Helper function to add array section
  //   const addArraySection = (title, items, itemTitle, fields) => {
  //     if (!items || items.length === 0) return;

  //     checkPageBreak(20);
  //     doc.setFontSize(14);
  //     doc.setTextColor(255, 156, 0);
  //     doc.text(`${title} (${items.length})`, leftMargin, yPos);
  //     yPos += 8;

  //     doc.setDrawColor(255, 156, 0);
  //     doc.line(leftMargin, yPos, rightMargin, yPos);
  //     yPos += 10;

  //     doc.setFontSize(10);
  //     doc.setTextColor(0, 0, 0);

  //     items.forEach((item, index) => {
  //       checkPageBreak(20);

  //       doc.setFontSize(12);
  //       doc.setFont("helvetica", "bold");
  //       doc.text(`${itemTitle} ${index + 1}`, leftMargin, yPos);
  //       yPos += 8;

  //       doc.setDrawColor(200, 200, 200);
  //       doc.line(leftMargin, yPos, rightMargin, yPos);
  //       yPos += 10;

  //       doc.setFontSize(10);
  //       fields.forEach(({ label, key }) => {
  //         const value = item[key];
  //         if (!value) return;

  //         checkPageBreak(8);

  //         doc.setFont("helvetica", "bold");
  //         doc.text(`${label}:`, leftMargin + 10, yPos);

  //         doc.setFont("helvetica", "normal");
  //         const valueText = value?.toString() || "N/A";
  //         const lines = addTextWithWrap(
  //           valueText,
  //           leftMargin + 80,
  //           yPos,
  //           rightMargin - leftMargin - 80,
  //         );

  //         yPos += lines * 7 + 2;
  //       });

  //       yPos += 5;
  //     });
  //   };

  //   // Helper function to add language test section
  //   const addLanguageTestSection = (personData, personName) => {
  //     if (!personData || personData.languageTestTaken !== "Yes") return;

  //     checkPageBreak(20);
  //     doc.setFontSize(14);
  //     doc.setTextColor(255, 156, 0);
  //     doc.text(`${personName} LANGUAGE TEST DETAILS`, leftMargin, yPos);
  //     yPos += 8;

  //     doc.setDrawColor(255, 156, 0);
  //     doc.line(leftMargin, yPos, rightMargin, yPos);
  //     yPos += 10;

  //     doc.setFontSize(10);
  //     doc.setTextColor(0, 0, 0);

  //     const testFields = [
  //       { label: "Test Type", value: personData.typeOfTest },
  //       { label: "Test Version", value: personData.languageTestVersion },
  //       { label: "Date of Test", value: formatDate(personData.dateOfTest) },
  //       {
  //         label: "Date of Result",
  //         value: formatDate(personData.dateOfTestResult),
  //       },
  //       {
  //         label: "Certificate No",
  //         value: personData.languageTestCertificateNo,
  //       },
  //     ];

  //     if (personData.typeOfTest === "IELTS") {
  //       testFields.push({
  //         label: "IELTS Certificate No",
  //         value: personData.IELTScertificateNo,
  //       });
  //     } else if (personData.typeOfTest === "CELPIP") {
  //       testFields.push(
  //         { label: "CELPIP Reg No", value: personData.CELPIPregNo },
  //         { label: "CELPIP PIN No", value: personData.CELPIPpinNo },
  //       );
  //     } else if (personData.typeOfTest === "PTE") {
  //       testFields.push(
  //         { label: "PTE Report Code", value: personData.PTEreportCode },
  //         { label: "PTE Test Taker ID", value: personData.PTEtestTakerId },
  //         { label: "PTE Reg ID", value: personData.PTEregId },
  //       );
  //     }

  //     testFields.push(
  //       { label: "Speaking", value: personData.speaking },
  //       { label: "Reading", value: personData.reading },
  //       { label: "Listening", value: personData.listening },
  //       { label: "Writing", value: personData.writing },
  //       {
  //         label: "French Test Taken",
  //         value: personData.takenAnApprovedTestForFrench,
  //       },
  //     );

  //     testFields.forEach(({ label, value }) => {
  //       if (!value || value === "N/A") return;

  //       checkPageBreak(8);

  //       doc.setFont("helvetica", "bold");
  //       doc.text(`${label}:`, leftMargin, yPos);

  //       doc.setFont("helvetica", "normal");
  //       const valueText = value || "N/A";
  //       const lines = addTextWithWrap(
  //         valueText,
  //         leftMargin + 70,
  //         yPos,
  //         rightMargin - leftMargin - 70,
  //       );

  //       yPos += lines * 7 + 2;
  //     });

  //     yPos += 5;
  //   };

  //   // Helper function to add ECA section
  //   const addECASection = (personData, personName) => {
  //     if (!personData || !personData.ECAOrganization) return;

  //     checkPageBreak(20);
  //     doc.setFontSize(14);
  //     doc.setTextColor(255, 156, 0);
  //     doc.text(`${personName} ECA DETAILS`, leftMargin, yPos);
  //     yPos += 8;

  //     doc.setDrawColor(255, 156, 0);
  //     doc.line(leftMargin, yPos, rightMargin, yPos);
  //     yPos += 10;

  //     doc.setFontSize(10);
  //     doc.setTextColor(0, 0, 0);

  //     const ecaFields = [
  //       { label: "Organization", value: personData.ECAOrganization },
  //       {
  //         label: "Report Issue Date",
  //         value: formatDate(personData.dateECAreportIssued),
  //       },
  //       { label: "Certificate No", value: personData.ECAcertificateNo },
  //       { label: "Equivalency", value: personData.ECAequivalency },
  //     ];

  //     ecaFields.forEach(({ label, value }) => {
  //       if (!value || value === "N/A") return;

  //       checkPageBreak(8);

  //       doc.setFont("helvetica", "bold");
  //       doc.text(`${label}:`, leftMargin, yPos);

  //       doc.setFont("helvetica", "normal");
  //       const valueText = value || "N/A";
  //       const lines = addTextWithWrap(
  //         valueText,
  //         leftMargin + 70,
  //         yPos,
  //         rightMargin - leftMargin - 70,
  //       );

  //       yPos += lines * 7 + 2;
  //     });

  //     yPos += 5;
  //   };

  //   // Helper function to add declarations for a person
  //   const addDeclarationsForPerson = (personData, personName) => {
  //     const declarations = [
  //       {
  //         question: "Has applicant been refused visa or permit?",
  //         answer:
  //           personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry,
  //         remarks:
  //           personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks,
  //       },
  //       {
  //         question: "Has applicant committed any criminal offence?",
  //         answer:
  //           personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry,
  //         remarks:
  //           personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks,
  //       },
  //       {
  //         question: "Has applicant been detained or incarcerated?",
  //         answer: personData?.HasApplicantBeenDetainedIncarceratedorPutinJail,
  //         remarks:
  //           personData?.HasApplicantBeenDetainedIncarceratedorPutinJailRemarks,
  //       },
  //       {
  //         question: "Has applicant been associated with armed groups?",
  //         answer:
  //           personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives,
  //         remarks:
  //           personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks,
  //       },
  //       {
  //         question: "Has applicant been involved in war crimes?",
  //         answer:
  //           personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity,
  //         remarks:
  //           personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks,
  //       },
  //       {
  //         question: "Has applicant been member of criminal organization?",
  //         answer:
  //           personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity,
  //         remarks:
  //           personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks,
  //       },
  //       {
  //         question: "Has applicant had serious disease or disorder?",
  //         answer:
  //           personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder,
  //         remarks:
  //           personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks,
  //       },
  //       {
  //         question: "Has applicant used/planned armed struggle?",
  //         answer:
  //           personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousorSocialObjectives,
  //         remarks:
  //           personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousorSocialObjectivesRemarks,
  //       },
  //       {
  //         question: "Has applicant been convicted in Canada without pardon?",
  //         answer:
  //           personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada,
  //         remarks:
  //           personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks,
  //       },
  //     ];

  //     const hasDeclarations = declarations.some(
  //       (decl) => decl.answer || (decl.remarks && decl.remarks.trim() !== ""),
  //     );

  //     if (!hasDeclarations) return;

  //     checkPageBreak(20);
  //     doc.setFontSize(14);
  //     doc.setTextColor(255, 156, 0);
  //     doc.text(`${personName} DECLARATIONS`, leftMargin, yPos);
  //     yPos += 8;

  //     doc.setDrawColor(255, 156, 0);
  //     doc.line(leftMargin, yPos, rightMargin, yPos);
  //     yPos += 10;

  //     doc.setFontSize(10);

  //     declarations.forEach((decl) => {
  //       const answer = decl.answer;
  //       const remarks = decl.remarks;

  //       if (!answer && !(remarks && remarks.trim() !== "")) return;

  //       checkPageBreak(15);

  //       if (answer === "Yes") {
  //         doc.setTextColor(220, 53, 69);
  //       } else if (answer === "No") {
  //         doc.setTextColor(40, 167, 69);
  //       } else {
  //         doc.setTextColor(0, 0, 0);
  //       }

  //       doc.setFont("helvetica", "bold");
  //       const questionText = `• ${decl.question}: ${formatResponse(answer)}`;
  //       const questionLines = addTextWithWrap(
  //         questionText,
  //         leftMargin,
  //         yPos,
  //         rightMargin - leftMargin,
  //       );
  //       yPos += questionLines * 7;

  //       if (remarks && remarks.trim() !== "") {
  //         checkPageBreak(8);
  //         doc.setTextColor(100, 100, 100);
  //         doc.setFont("helvetica", "italic");
  //         const remarksText = `  Remarks: ${remarks}`;
  //         const remarksLines = addTextWithWrap(
  //           remarksText,
  //           leftMargin + 5,
  //           yPos,
  //           rightMargin - leftMargin - 5,
  //         );
  //         yPos += remarksLines * 6;
  //       }

  //       doc.setTextColor(0, 0, 0);
  //       yPos += 3;
  //     });

  //     yPos += 5;
  //   };

  //   // Start building PDF
  //   if (fullFormData) {
  //     // Primary Applicant Information
  //     const primaryInfo = [
  //       {
  //         label: "Name",
  //         value: `${fullFormData.firstName || ""} ${fullFormData.middleName || ""} ${fullFormData.lastName || ""}`,
  //       },
  //       { label: "Date of Birth", value: formatDate(fullFormData.dateOfBirth) },
  //       { label: "Gender", value: fullFormData.gender },
  //       { label: "Email", value: fullFormData.emailId },
  //       { label: "Telephone", value: fullFormData.telephoneNo },
  //       { label: "Passport No", value: fullFormData.passportNo },
  //       {
  //         label: "Country of Citizenship",
  //         value: fullFormData.countryOfCitizenship,
  //       },
  //       { label: "Country of Birth", value: fullFormData.countryOfBirth },
  //       { label: "City of Birth", value: fullFormData.cityOfBirth },
  //       { label: "Marital Status", value: fullFormData.maritalStatus },
  //       { label: "NOC Code", value: fullFormData.NOCcode },
  //       { label: "EE Profile No", value: fullFormData.EEno },
  //       { label: "UCI No", value: fullFormData.UCIno },
  //       { label: "CSQ", value: fullFormData.CSQ },
  //       { label: "CSQ Remarks", value: fullFormData.CSQRemarks },
  //       { label: "UNHCR", value: fullFormData.UNHCR },
  //       { label: "UNHCR Remarks", value: fullFormData.UNHCRRemarks },
  //       { label: "Native Language", value: fullFormData.nativeLanguage },
  //       { label: "Other Name", value: fullFormData.otherName },
  //       { label: "Status in Canada", value: fullFormData.statusInCanada },
  //       {
  //         label: "Place Entered in Canada",
  //         value: fullFormData.placeOfEnteredInCanada,
  //       },
  //       {
  //         label: "First Time Entered",
  //         value: formatDate(fullFormData.firstTimeEnteredInCanada),
  //       },
  //       {
  //         label: "Last Time Entered",
  //         value: formatDate(fullFormData.lastTimeEnteredInCanada),
  //       },
  //     ];

  //     addSection("PRIMARY APPLICANT INFORMATION", primaryInfo);

  //     // Primary Applicant Education History
  //     if (
  //       fullFormData.educationHistory &&
  //       fullFormData.educationHistory.length > 0
  //     ) {
  //       addArraySection(
  //         "PRIMARY APPLICANT EDUCATION HISTORY",
  //         fullFormData.educationHistory,
  //         "Education",
  //         [
  //           { label: "Level of Education", key: "levelOfEducation" },
  //           { label: "Field of Study", key: "studyName" },
  //           { label: "From Date", key: "fromDate", format: formatDate },
  //           { label: "To Date", key: "toDate", format: formatDate },
  //           { label: "City of Education", key: "cityOfEducation" },
  //           { label: "Country of Education", key: "countryOfEducation" },
  //           { label: "Institution Name", key: "nameOfInstitution" },
  //           { label: "Institution Address", key: "addressOfInstitution" },
  //           { label: "DLI Number", key: "designatedLearningInstituteNo" },
  //           { label: "Campus City", key: "cityOfCampusAttended" },
  //         ],
  //       );
  //     }

  //     // Primary Applicant Language Test
  //     addLanguageTestSection(fullFormData, "PRIMARY APPLICANT");

  //     // Primary Applicant ECA
  //     addECASection(fullFormData, "PRIMARY APPLICANT");

  //     // Primary Applicant Work History
  //     if (fullFormData.workHistory && fullFormData.workHistory.length > 0) {
  //       addArraySection(
  //         "PRIMARY APPLICANT WORK HISTORY",
  //         fullFormData.workHistory,
  //         "Work Experience",
  //         [
  //           { label: "Job Title", key: "jobTitle" },
  //           { label: "From Date", key: "jobFromDate", format: formatDate },
  //           { label: "To Date", key: "jobToDate", format: formatDate },
  //           {
  //             label: "Employment Type",
  //             key: "fullTimeOrPartTime",
  //             format: (v) => (v === "full" ? "Full Time" : "Part Time"),
  //           },
  //           { label: "Hours/Week", key: "hoursPerWeek" },
  //           { label: "NOC Code", key: "NOCcode" },
  //           { label: "Company Name", key: "companyName" },
  //           { label: "Company Address", key: "companyAddressWithPostalCode" },
  //         ],
  //       );
  //     }

  //     // Primary Applicant Employment Status
  //     const employmentInfo = [
  //       {
  //         label: "Working Legally in Canada",
  //         value: fullFormData.workingLegallyInCanada,
  //       },
  //       {
  //         label: "Primary Occupation/NOC Code",
  //         value: fullFormData.primaryOccupationOrNOCcode,
  //       },
  //       {
  //         label: "Has Job Offer/LMIA",
  //         value: fullFormData.havingAnyJOBOFFERorLMIAInCanada,
  //       },
  //     ];

  //     addSection("PRIMARY APPLICANT EMPLOYMENT STATUS", employmentInfo);

  //     // Primary Applicant Relatives in Canada
  //     if (fullFormData.relativesInCanada === "Yes") {
  //       const relativesInfo = [
  //         {
  //           label: "Has Relatives in Canada",
  //           value: fullFormData.relativesInCanada,
  //         },
  //         {
  //           label: "Resident Status",
  //           value: fullFormData.relativesInCanadaResidentWith,
  //         },
  //       ];
  //       addSection("RELATIVES IN CANADA", relativesInfo);
  //     }

  //     // Primary Applicant Address Information
  //     const addressInfo = [
  //       { label: "Mailing Address", value: fullFormData.mailingAddress },
  //       { label: "Permanent Address", value: fullFormData.permanentAddress },
  //       {
  //         label: "City/Province of Residence",
  //         value: fullFormData.cityOrProvinceOfResidence,
  //       },
  //       {
  //         label: "Current Country of Residence",
  //         value: fullFormData.currentCountryOfResidence,
  //       },
  //       {
  //         label: "Province Considering Living",
  //         value: fullFormData.provinceOfConsiderLiving,
  //       },
  //       {
  //         label: "Money to Bring to Canada",
  //         value: fullFormData.moneyBroughtToCanada,
  //       },
  //       {
  //         label: "Total Family Members",
  //         value: fullFormData.totalFamilyMemberIncludingSpouseAndChild,
  //       },
  //       { label: "Spouse Count", value: fullFormData.spouseCount },
  //       { label: "Child Count", value: fullFormData.childCount },
  //       {
  //         label: "Applied to Express Entry Before",
  //         value: fullFormData.didAppliedToExpressEntryCanadaBefore,
  //       },
  //       {
  //         label: "Received Nomination Certificate",
  //         value:
  //           fullFormData.receivedNominationCertificateFromProvinceOrTerritory,
  //       },
  //       { label: "Relation", value: fullFormData.relation },
  //     ];

  //     addSection("ADDRESS & ADDITIONAL INFORMATION", addressInfo);

  //     // Primary Applicant Declarations
  //     addDeclarationsForPerson(fullFormData, "PRIMARY APPLICANT");

  //     // Spouse Information if exists
  //     if (fullFormData.PrimaryApplicantSpouseData) {
  //       const spouse = fullFormData.PrimaryApplicantSpouseData;

  //       const spouseInfo = [
  //         {
  //           label: "Name",
  //           value: `${spouse.firstName || ""} ${spouse.middleName || ""} ${spouse.lastName || ""}`,
  //         },
  //         { label: "Date of Birth", value: formatDate(spouse.dateOfBirth) },
  //         { label: "Gender", value: spouse.gender },
  //         { label: "Email", value: spouse.emailId },
  //         { label: "Telephone", value: spouse.telephoneNo },
  //         { label: "Passport No", value: spouse.passportNo },
  //         {
  //           label: "Country of Citizenship",
  //           value: spouse.countryOfCitizenship,
  //         },
  //         { label: "Country of Birth", value: spouse.countryOfBirth },
  //         { label: "City of Birth", value: spouse.cityOfBirth },
  //         {
  //           label: "Date of Marriage",
  //           value: formatDate(spouse.dateOfMarriage),
  //         },
  //         { label: "NOC Code", value: spouse.NOCcode },
  //         { label: "EE Profile No", value: spouse.EEno },
  //         { label: "UCI No", value: spouse.UCIno },
  //         { label: "CSQ", value: spouse.CSQ },
  //         { label: "CSQ Remarks", value: spouse.CSQRemarks },
  //         { label: "UNHCR", value: spouse.UNHCR },
  //         { label: "UNHCR Remarks", value: spouse.UNHCRRemarks },
  //         { label: "Status in Canada", value: spouse.statusInCanada },
  //       ];

  //       addSection("SPOUSE INFORMATION", spouseInfo);

  //       // Spouse Education History
  //       if (spouse.educationHistory && spouse.educationHistory.length > 0) {
  //         addArraySection(
  //           "SPOUSE EDUCATION HISTORY",
  //           spouse.educationHistory,
  //           "Education",
  //           [
  //             { label: "Level of Education", key: "levelOfEducation" },
  //             { label: "Field of Study", key: "studyName" },
  //             { label: "From Date", key: "fromDate", format: formatDate },
  //             { label: "To Date", key: "toDate", format: formatDate },
  //             { label: "City of Education", key: "cityOfEducation" },
  //             { label: "Country of Education", key: "countryOfEducation" },
  //             { label: "Institution Name", key: "nameOfInstitution" },
  //             { label: "Institution Address", key: "addressOfInstitution" },
  //             { label: "DLI Number", key: "designatedLearningInstituteNo" },
  //             { label: "Campus City", key: "cityOfCampusAttended" },
  //           ],
  //         );
  //       }

  //       // Spouse Language Test
  //       addLanguageTestSection(spouse, "SPOUSE");

  //       // Spouse ECA
  //       addECASection(spouse, "SPOUSE");

  //       // Spouse Work History
  //       if (spouse.workHistory && spouse.workHistory.length > 0) {
  //         addArraySection(
  //           "SPOUSE WORK HISTORY",
  //           spouse.workHistory,
  //           "Work Experience",
  //           [
  //             { label: "Job Title", key: "jobTitle" },
  //             { label: "From Date", key: "jobFromDate", format: formatDate },
  //             { label: "To Date", key: "jobToDate", format: formatDate },
  //             {
  //               label: "Employment Type",
  //               key: "fullTimeOrPartTime",
  //               format: (v) => (v === "full" ? "Full Time" : "Part Time"),
  //             },
  //             { label: "Hours/Week", key: "hoursPerWeek" },
  //             { label: "NOC Code", key: "NOCcode" },
  //             { label: "Company Name", key: "companyName" },
  //             { label: "Company Address", key: "companyAddressWithPostalCode" },
  //           ],
  //         );
  //       }

  //       // Spouse Employment Status
  //       const spouseEmploymentInfo = [
  //         {
  //           label: "Working Legally in Canada",
  //           value: spouse.workingLegallyInCanada,
  //         },
  //         {
  //           label: "Primary Occupation/NOC Code",
  //           value: spouse.primaryOccupationOrNOCcode,
  //         },
  //         {
  //           label: "Has Job Offer/LMIA",
  //           value: spouse.havingAnyJOBOFFERorLMIAInCanada,
  //         },
  //       ];

  //       addSection("SPOUSE EMPLOYMENT STATUS", spouseEmploymentInfo);

  //       // Spouse Declarations
  //       addDeclarationsForPerson(spouse, "SPOUSE");
  //     }

  //     // Children Information if exists
  //     if (
  //       fullFormData.PrimaryApplicantChildData &&
  //       fullFormData.PrimaryApplicantChildData.length > 0
  //     ) {
  //       fullFormData.PrimaryApplicantChildData.forEach((child, index) => {
  //         const childInfo = [
  //           {
  //             label: "Name",
  //             value: `${child.firstName || ""} ${child.middleName || ""} ${child.lastName || ""}`,
  //           },
  //           { label: "Date of Birth", value: formatDate(child.dateOfBirth) },
  //           { label: "Gender", value: child.gender },
  //           { label: "Email", value: child.emailId },
  //           { label: "Telephone", value: child.telephoneNo },
  //           { label: "Passport No", value: child.passportNo },
  //           {
  //             label: "Country of Citizenship",
  //             value: child.countryOfCitizenship,
  //           },
  //           { label: "Country of Birth", value: child.countryOfBirth },
  //           { label: "City of Birth", value: child.cityOfBirth },
  //           { label: "CSQ", value: child.CSQ },
  //           { label: "CSQ Remarks", value: child.CSQRemarks },
  //           { label: "UNHCR", value: child.UNHCR },
  //           { label: "UNHCR Remarks", value: child.UNHCRRemarks },
  //           { label: "EE Profile No", value: child.EEno },
  //           { label: "UCI No", value: child.UCIno },
  //           { label: "Relation", value: child.relation },
  //         ];

  //         addSection(`CHILD ${index + 1} INFORMATION`, childInfo);
  //         addDeclarationsForPerson(child, `CHILD ${index + 1}`);
  //       });
  //     }

  //     // Submission Information
  //     const submissionInfo = [
  //       { label: "Created At", value: formatDate(fullFormData.createdAt) },
  //       { label: "User ID", value: fullFormData.userId },
  //       {
  //         label: "Status",
  //         value: fullFormData.isFinallySubmittedForm ? "Submitted" : "Draft",
  //       },
  //     ];

  //     addSection("SUBMISSION INFORMATION", submissionInfo);
  //   }

  //   // Footer
  //   checkPageBreak(20);
  //   doc.setFontSize(8);
  //   doc.setTextColor(100, 100, 100);
  //   doc.text(
  //     "Generated by Immigration Application System",
  //     105,
  //     yPos,
  //     null,
  //     null,
  //     "center",
  //   );
  //   doc.text(
  //     `Generated on: ${new Date().toLocaleString()}`,
  //     105,
  //     yPos + 5,
  //     null,
  //     null,
  //     "center",
  //   );

  //   // Save PDF
  //   doc.save(`Immigration-Application-${fullFormData?._id || "form"}.pdf`);
  // };

  const downloadPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(20);
    doc.setTextColor(255, 156, 0); // #ff9c00
    doc.text("IMMIGRATION APPLICATION FORM", 105, 15, null, null, "center");

    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);
    doc.text(`Application ID: ${fullFormData?._id || "N/A"}`, 15, 25);
    // doc.text(`Date: ${new Date().toLocaleDateString()}`, 180, 25);
    doc.text(`Date: ${new Date().toLocaleDateString("en-GB")}`, 180, 25);

    let yPos = 35;
    const leftMargin = 15;
    const rightMargin = 195;
    const pageHeight = 280;

    // Helper function to add text with word wrap
    const addTextWithWrap = (text, x, y, maxWidth) => {
      if (!text || text === "N/A") return 0;
      const lines = doc.splitTextToSize(text.toString(), maxWidth);
      doc.text(lines, x, y);
      return lines.length;
    };

    // Helper function to check page break
    const checkPageBreak = (requiredSpace = 10) => {
      if (yPos + requiredSpace > pageHeight) {
        doc.addPage();
        yPos = 20;
        return true;
      }
      return false;
    };

    // Helper function to add section
    const addSection = (title, contentLines) => {
      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(title, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      contentLines.forEach(({ label, value }) => {
        if (!value || value === "N/A") return;

        checkPageBreak(8);

        doc.setFont("helvetica", "bold");
        doc.text(`${label}:`, leftMargin, yPos);

        doc.setFont("helvetica", "normal");
        const valueText = value || "N/A";
        const lines = addTextWithWrap(
          valueText,
          leftMargin + 70,
          yPos,
          rightMargin - leftMargin - 70,
        );

        yPos += lines * 7 + 2;
      });

      yPos += 5;
    };

    // Helper function to add array section
    const addArraySection = (title, items, itemTitle, fields) => {
      if (!items || items.length === 0) return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${title} (${items.length})`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      items.forEach((item, index) => {
        checkPageBreak(20);

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.text(`${itemTitle} ${index + 1}`, leftMargin, yPos);
        yPos += 8;

        doc.setDrawColor(200, 200, 200);
        doc.line(leftMargin, yPos, rightMargin, yPos);
        yPos += 10;

        doc.setFontSize(10);
        fields.forEach(({ label, key }) => {
          const value = item[key];
          if (!value) return;

          checkPageBreak(8);

          doc.setFont("helvetica", "bold");
          doc.text(`${label}:`, leftMargin + 10, yPos);

          doc.setFont("helvetica", "normal");
          const valueText = value?.toString() || "N/A";
          const lines = addTextWithWrap(
            // valueText,
            key === "fromDate" ||
              key === "toDate" ||
              key === "jobFromDate" ||
              key === "jobToDate"
              ? formatDate(valueText)
              : valueText,
            leftMargin + 80,
            yPos,
            rightMargin - leftMargin - 80,
          );

          yPos += lines * 7 + 2;
        });

        yPos += 5;
      });
    };

    // Helper function to add language test section
    const addLanguageTestSection = (personData, personName) => {
      if (!personData || personData.languageTestTaken !== "Yes") return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${personName} LANGUAGE TEST DETAILS`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      const testFields = [
        { label: "Test Type", value: personData.typeOfTest },
        { label: "Test Version", value: personData.languageTestVersion },
        { label: "Date of Test", value: formatDate(personData.dateOfTest) },
        {
          label: "Date of Result",
          value: formatDate(personData.dateOfTestResult),
        },
        {
          label: "Certificate No",
          value: personData.languageTestCertificateNo,
        },
      ];

      if (personData.typeOfTest === "IELTS") {
        testFields.push({
          label: "IELTS Certificate No",
          value: personData.IELTScertificateNo,
        });
      } else if (personData.typeOfTest === "CELPIP") {
        testFields.push(
          { label: "CELPIP Reg No", value: personData.CELPIPregNo },
          { label: "CELPIP PIN No", value: personData.CELPIPpinNo },
        );
      } else if (personData.typeOfTest === "PTE") {
        testFields.push(
          { label: "PTE Report Code", value: personData.PTEreportCode },
          { label: "PTE Test Taker ID", value: personData.PTEtestTakerId },
          { label: "PTE Reg ID", value: personData.PTEregId },
        );
      }

      testFields.push(
        { label: "Speaking", value: personData.speaking },
        { label: "Reading", value: personData.reading },
        { label: "Listening", value: personData.listening },
        { label: "Writing", value: personData.writing },
        {
          label: "French Test Taken",
          value: personData.takenAnApprovedTestForFrench,
        },
      );

      testFields.forEach(({ label, value }) => {
        if (!value || value === "N/A") return;

        checkPageBreak(8);

        doc.setFont("helvetica", "bold");
        doc.text(`${label}:`, leftMargin, yPos);

        doc.setFont("helvetica", "normal");
        const valueText = value || "N/A";
        const lines = addTextWithWrap(
          valueText,
          leftMargin + 70,
          yPos,
          rightMargin - leftMargin - 70,
        );

        yPos += lines * 7 + 2;
      });

      yPos += 5;
    };

    // Helper function to add ECA section
    const addECASection = (personData, personName) => {
      if (!personData || !personData.ECAOrganization) return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${personName} ECA DETAILS`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);

      const ecaFields = [
        { label: "Organization", value: personData.ECAOrganization },
        {
          label: "Report Issue Date",
          value: formatDate(personData.dateECAreportIssued),
        },
        { label: "Certificate No", value: personData.ECAcertificateNo },
        { label: "Equivalency", value: personData.ECAequivalency },
      ];

      ecaFields.forEach(({ label, value }) => {
        if (!value || value === "N/A") return;

        checkPageBreak(8);

        doc.setFont("helvetica", "bold");
        doc.text(`${label}:`, leftMargin, yPos);

        doc.setFont("helvetica", "normal");
        const valueText = value || "N/A";
        const lines = addTextWithWrap(
          valueText,
          leftMargin + 70,
          yPos,
          rightMargin - leftMargin - 70,
        );

        yPos += lines * 7 + 2;
      });

      yPos += 5;
    };

    // Helper function to add declarations for a person
    const addDeclarationsForPerson = (personData, personName) => {
      const declarations = [
        {
          question: "Has applicant been refused visa or permit?",
          answer:
            personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountry,
          remarks:
            personData?.HasApplicantEverBeenRefusedVisaOrPermitDeniedEntryOrOrderedToLeaveCanadaOrAnyOtherCountryRemarks,
        },
        {
          question: "Has applicant committed any criminal offence?",
          answer:
            personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountry,
          remarks:
            personData?.HasApplicantEverCommittedBeenArrestedForBeenChargedWithOrConvictedOfAnyCriminalOffenceInAnyCountryRemarks,
        },
        {
          question: "Has applicant been detained or incarcerated?",
          answer: personData?.HasApplicantBeenDetainedIncarceratedorPutinJail,
          remarks:
            personData?.HasApplicantBeenDetainedIncarceratedorPutinJailRemarks,
        },
        {
          question: "Has applicant been associated with armed groups?",
          answer:
            personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectives,
          remarks:
            personData?.HasApplicantBeenAssociatedWithaGroupThatUsesAdvocatedorAdvocatestheUseofArmedStruggleorViolencetoReachPoliticalReligiousorSocialObjectivesRemarks,
        },
        {
          question: "Has applicant been involved in war crimes?",
          answer:
            personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanity,
          remarks:
            personData?.HasApplicantBeenInvolvedActOfGenocideWarCrimeOrInTheCommissionOfCrimeAgainstHumanityRemarks,
        },
        {
          question: "Has applicant been member of criminal organization?",
          answer:
            personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivity,
          remarks:
            personData?.HasApplicantBeenMemberofanOrganizationThatisorWasEngagedinanActivityThatisPartOfPatternOfCriminalActivityRemarks,
        },
        {
          question: "Has applicant had serious disease or disorder?",
          answer:
            personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorder,
          remarks:
            personData?.HasApplicantHadAnySeriousDiseaseorPhysicalorMentalDisorderRemarks,
        },
        {
          question: "Has applicant used/planned armed struggle?",
          answer:
            personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousorSocialObjectives,
          remarks:
            personData?.HasApplicantUsedPlannedOrAdvocatedTheUseOfArmedStruggleOrViolenceToReachPoliticalReligiousorSocialObjectivesRemarks,
        },
        {
          question: "Has applicant been convicted in Canada without pardon?",
          answer:
            personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanada,
          remarks:
            personData?.HasApplicantbeenConvictedOfCrimeOrOffenceInCanadaForwhichPardonHasNotBeenGrantedUnderTheCriminalRecordsActOfCanadaRemarks,
        },
      ];

      const hasDeclarations = declarations.some(
        (decl) => decl.answer || (decl.remarks && decl.remarks.trim() !== ""),
      );

      if (!hasDeclarations) return;

      checkPageBreak(20);
      doc.setFontSize(14);
      doc.setTextColor(255, 156, 0);
      doc.text(`${personName} DECLARATIONS`, leftMargin, yPos);
      yPos += 8;

      doc.setDrawColor(255, 156, 0);
      doc.line(leftMargin, yPos, rightMargin, yPos);
      yPos += 10;

      doc.setFontSize(10);

      declarations.forEach((decl) => {
        const answer = decl.answer;
        const remarks = decl.remarks;

        if (!answer && !(remarks && remarks.trim() !== "")) return;

        checkPageBreak(15);

        if (answer === "Yes") {
          doc.setTextColor(220, 53, 69);
        } else if (answer === "No") {
          doc.setTextColor(40, 167, 69);
        } else {
          doc.setTextColor(0, 0, 0);
        }

        doc.setFont("helvetica", "bold");
        const questionText = `• ${decl.question}: ${formatResponse(answer)}`;
        const questionLines = addTextWithWrap(
          questionText,
          leftMargin,
          yPos,
          rightMargin - leftMargin,
        );
        yPos += questionLines * 7;

        if (remarks && remarks.trim() !== "") {
          checkPageBreak(8);
          doc.setTextColor(100, 100, 100);
          doc.setFont("helvetica", "italic");
          const remarksText = `  Remarks: ${remarks}`;
          const remarksLines = addTextWithWrap(
            remarksText,
            leftMargin + 5,
            yPos,
            rightMargin - leftMargin - 5,
          );
          yPos += remarksLines * 6;
        }

        doc.setTextColor(0, 0, 0);
        yPos += 3;
      });

      yPos += 5;
    };

    // Start building PDF
    if (fullFormData) {
      // Primary Applicant Information
      const primaryInfo = [
        {
          label: "Name",
          value: `${fullFormData.firstName || ""} ${fullFormData.middleName || ""} ${fullFormData.lastName || ""}`,
        },
        { label: "Date of Birth", value: formatDate(fullFormData.dateOfBirth) },
        { label: "Gender", value: fullFormData.gender },
        { label: "Email", value: fullFormData.emailId },
        { label: "Telephone", value: fullFormData.telephoneNo },
        { label: "Passport No", value: fullFormData.passportNo },
        {
          label: "Country of Citizenship",
          value: fullFormData.countryOfCitizenship,
        },
        { label: "Country of Birth", value: fullFormData.countryOfBirth },
        { label: "City of Birth", value: fullFormData.cityOfBirth },
        { label: "Marital Status", value: fullFormData.maritalStatus },
        { label: "NOC Code", value: fullFormData.NOCcode },
        { label: "EE Profile No", value: fullFormData.EEno },
        { label: "UCI No", value: fullFormData.UCIno },
        { label: "CSQ", value: fullFormData.CSQ },
        { label: "CSQ Remarks", value: fullFormData.CSQRemarks },
        { label: "UNHCR", value: fullFormData.UNHCR },
        { label: "UNHCR Remarks", value: fullFormData.UNHCRRemarks },
        { label: "Native Language", value: fullFormData.nativeLanguage },
        { label: "Other Name", value: fullFormData.otherName },
        { label: "Status in Canada", value: fullFormData.statusInCanada },
        {
          label: "Place Entered in Canada",
          value: fullFormData.placeOfEnteredInCanada,
        },
        {
          label: "First Time Entered",
          value: formatDate(fullFormData.firstTimeEnteredInCanada),
        },
        {
          label: "Last Time Entered",
          value: formatDate(fullFormData.lastTimeEnteredInCanada),
        },
      ];

      addSection("PRIMARY APPLICANT INFORMATION", primaryInfo);

      // Primary Applicant Education History
      if (
        fullFormData.educationHistory &&
        fullFormData.educationHistory.length > 0
      ) {
        addArraySection(
          "PRIMARY APPLICANT EDUCATION HISTORY",
          fullFormData.educationHistory,
          "Education",
          [
            { label: "Level of Education", key: "levelOfEducation" },
            { label: "Field of Study", key: "studyName" },
            { label: "From Date", key: "fromDate", format: formatDate },
            { label: "To Date", key: "toDate", format: formatDate },
            { label: "City of Education", key: "cityOfEducation" },
            { label: "Country of Education", key: "countryOfEducation" },
            { label: "Institution Name", key: "nameOfInstitution" },
            { label: "Institution Address", key: "addressOfInstitution" },
            { label: "DLI Number", key: "designatedLearningInstituteNo" },
            { label: "Campus City", key: "cityOfCampusAttended" },
          ],
        );
      }

      // Primary Applicant Language Test
      addLanguageTestSection(fullFormData, "PRIMARY APPLICANT");

      // Primary Applicant ECA
      addECASection(fullFormData, "PRIMARY APPLICANT");

      // Primary Applicant Work History
      if (fullFormData.workHistory && fullFormData.workHistory.length > 0) {
        addArraySection(
          "PRIMARY APPLICANT WORK HISTORY",
          fullFormData.workHistory,
          "Work Experience",
          [
            { label: "Job Title", key: "jobTitle" },
            { label: "From Date", key: "jobFromDate", format: formatDate },
            { label: "To Date", key: "jobToDate", format: formatDate },
            {
              label: "Employment Type",
              key: "fullTimeOrPartTime",
              format: (v) => (v === "full" ? "Full Time" : "Part Time"),
            },
            { label: "Hours/Week", key: "hoursPerWeek" },
            { label: "NOC Code", key: "NOCcode" },
            { label: "Company Name", key: "companyName" },
            { label: "Company Address", key: "companyAddressWithPostalCode" },
          ],
        );
      }

      // Primary Applicant Employment Status
      const employmentInfo = [
        {
          label: "Working Legally in Canada",
          value: fullFormData.workingLegallyInCanada,
        },
        {
          label: "Primary Occupation/NOC Code",
          value: fullFormData.primaryOccupationOrNOCcode,
        },
        {
          label: "Has Job Offer/LMIA",
          value: fullFormData.havingAnyJOBOFFERorLMIAInCanada,
        },
      ];

      addSection("PRIMARY APPLICANT EMPLOYMENT STATUS", employmentInfo);

      // Primary Applicant Relatives in Canada
      if (fullFormData.relativesInCanada === "Yes") {
        const relativesInfo = [
          {
            label: "Has Relatives in Canada",
            value: fullFormData.relativesInCanada,
          },
          {
            label: "Resident Status",
            value: fullFormData.relativesInCanadaResidentWith,
          },
        ];
        addSection("RELATIVES IN CANADA", relativesInfo);
      }

      // Primary Applicant Address Information
      const addressInfo = [
        { label: "Mailing Address", value: fullFormData.mailingAddress },
        { label: "Permanent Address", value: fullFormData.permanentAddress },
        {
          label: "City/Province of Residence",
          value: fullFormData.cityOrProvinceOfResidence,
        },
        {
          label: "Current Country of Residence",
          value: fullFormData.currentCountryOfResidence,
        },
        {
          label: "Province Considering Living",
          value: fullFormData.provinceOfConsiderLiving,
        },
        {
          label: "Money to Bring to Canada",
          value: fullFormData.moneyBroughtToCanada,
        },
        {
          label: "Total Family Members",
          value: fullFormData.totalFamilyMemberIncludingSpouseAndChild,
        },
        { label: "Spouse Count", value: fullFormData.spouseCount },
        { label: "Child Count", value: fullFormData.childCount },
        {
          label: "Applied to Express Entry Before",
          value: fullFormData.didAppliedToExpressEntryCanadaBefore,
        },
        {
          label: "Received Nomination Certificate",
          value:
            fullFormData.receivedNominationCertificateFromProvinceOrTerritory,
        },
        { label: "Relation", value: fullFormData.relation },
      ];

      addSection("ADDRESS & ADDITIONAL INFORMATION", addressInfo);

      // Primary Applicant Declarations
      addDeclarationsForPerson(fullFormData, "PRIMARY APPLICANT");

      // Spouse Information if exists
      if (fullFormData.PrimaryApplicantSpouseData) {
        const spouse = fullFormData.PrimaryApplicantSpouseData;

        const spouseInfo = [
          {
            label: "Name",
            value: `${spouse.firstName || ""} ${spouse.middleName || ""} ${spouse.lastName || ""}`,
          },
          { label: "Date of Birth", value: formatDate(spouse.dateOfBirth) },
          { label: "Gender", value: spouse.gender },
          { label: "Email", value: spouse.emailId },
          { label: "Telephone", value: spouse.telephoneNo },
          { label: "Passport No", value: spouse.passportNo },
          {
            label: "Country of Citizenship",
            value: spouse.countryOfCitizenship,
          },
          { label: "Country of Birth", value: spouse.countryOfBirth },
          { label: "City of Birth", value: spouse.cityOfBirth },
          {
            label: "Date of Marriage",
            value: formatDate(spouse.dateOfMarriage),
          },
          { label: "NOC Code", value: spouse.NOCcode },
          { label: "EE Profile No", value: spouse.EEno },
          { label: "UCI No", value: spouse.UCIno },
          { label: "CSQ", value: spouse.CSQ },
          { label: "CSQ Remarks", value: spouse.CSQRemarks },
          { label: "UNHCR", value: spouse.UNHCR },
          { label: "UNHCR Remarks", value: spouse.UNHCRRemarks },
          { label: "Status in Canada", value: spouse.statusInCanada },
        ];

        addSection("SPOUSE INFORMATION", spouseInfo);

        // Spouse Education History
        if (spouse.educationHistory && spouse.educationHistory.length > 0) {
          addArraySection(
            "SPOUSE EDUCATION HISTORY",
            spouse.educationHistory,
            "Education",
            [
              { label: "Level of Education", key: "levelOfEducation" },
              { label: "Field of Study", key: "studyName" },
              { label: "From Date", key: "fromDate", format: formatDate },
              { label: "To Date", key: "toDate", format: formatDate },
              { label: "City of Education", key: "cityOfEducation" },
              { label: "Country of Education", key: "countryOfEducation" },
              { label: "Institution Name", key: "nameOfInstitution" },
              { label: "Institution Address", key: "addressOfInstitution" },
              { label: "DLI Number", key: "designatedLearningInstituteNo" },
              { label: "Campus City", key: "cityOfCampusAttended" },
            ],
          );
        }

        // Spouse Language Test
        addLanguageTestSection(spouse, "SPOUSE");

        // Spouse ECA
        addECASection(spouse, "SPOUSE");

        // Spouse Work History
        if (spouse.workHistory && spouse.workHistory.length > 0) {
          addArraySection(
            "SPOUSE WORK HISTORY",
            spouse.workHistory,
            "Work Experience",
            [
              { label: "Job Title", key: "jobTitle" },
              { label: "From Date", key: "jobFromDate", format: formatDate },
              { label: "To Date", key: "jobToDate", format: formatDate },
              {
                label: "Employment Type",
                key: "fullTimeOrPartTime",
                format: (v) => (v === "full" ? "Full Time" : "Part Time"),
              },
              { label: "Hours/Week", key: "hoursPerWeek" },
              { label: "NOC Code", key: "NOCcode" },
              { label: "Company Name", key: "companyName" },
              { label: "Company Address", key: "companyAddressWithPostalCode" },
            ],
          );
        }

        // Spouse Employment Status
        const spouseEmploymentInfo = [
          {
            label: "Working Legally in Canada",
            value: spouse.workingLegallyInCanada,
          },
          {
            label: "Primary Occupation/NOC Code",
            value: spouse.primaryOccupationOrNOCcode,
          },
          {
            label: "Has Job Offer/LMIA",
            value: spouse.havingAnyJOBOFFERorLMIAInCanada,
          },
        ];

        addSection("SPOUSE EMPLOYMENT STATUS", spouseEmploymentInfo);

        // Spouse Declarations
        addDeclarationsForPerson(spouse, "SPOUSE");
      }

      // Children Information if exists
      if (
        fullFormData.PrimaryApplicantChildData &&
        fullFormData.PrimaryApplicantChildData.length > 0
      ) {
        fullFormData.PrimaryApplicantChildData.forEach((child, index) => {
          const childInfo = [
            {
              label: "Name",
              value: `${child.firstName || ""} ${child.middleName || ""} ${child.lastName || ""}`,
            },
            { label: "Date of Birth", value: formatDate(child.dateOfBirth) },
            { label: "Gender", value: child.gender },
            { label: "Email", value: child.emailId },
            { label: "Telephone", value: child.telephoneNo },
            { label: "Passport No", value: child.passportNo },
            {
              label: "Country of Citizenship",
              value: child.countryOfCitizenship,
            },
            { label: "Country of Birth", value: child.countryOfBirth },
            { label: "City of Birth", value: child.cityOfBirth },
            { label: "CSQ", value: child.CSQ },
            { label: "CSQ Remarks", value: child.CSQRemarks },
            { label: "UNHCR", value: child.UNHCR },
            { label: "UNHCR Remarks", value: child.UNHCRRemarks },
            { label: "EE Profile No", value: child.EEno },
            { label: "UCI No", value: child.UCIno },
            { label: "Relation", value: child.relation },
          ];

          addSection(`CHILD ${index + 1} INFORMATION`, childInfo);
          addDeclarationsForPerson(child, `CHILD ${index + 1}`);
        });
      }

      // Submission Information
      const submissionInfo = [
        { label: "Created At", value: formatDate(fullFormData.createdAt) },
        { label: "User ID", value: fullFormData.userId },
        {
          label: "Status",
          value: fullFormData.isFinallySubmittedForm ? "Submitted" : "Draft",
        },
      ];

      addSection("SUBMISSION INFORMATION", submissionInfo);
    }

    // Footer
    checkPageBreak(20);
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text(
      "Generated by Immigration Application System",
      105,
      yPos,
      null,
      null,
      "center",
    );
    doc.text(
      `Filled By: ${fullFormData.firstName || ""} ${fullFormData.middleName || ""} ${fullFormData.lastName || ""}`,

      105,
      yPos + 5,
      null,
      null,
      "center",
    );
    doc.text(
      `Generated on: ${new Date().toLocaleDateString("en-GB")}`,

      105,
      yPos + 10,
      null,
      null,
      "center",
    );

    // Save PDF
    doc.save(`Immigration-Application-${fullFormData?._id || "form"}.pdf`);
  };

  if (!fullFormData) {
    return (
      <div className="container mt-5" style={{ marginLeft: "310px" }}>
        <div className="alert alert-warning" style={{ marginTop: "150px" }}>
          No form data available. Please go back and select a valid application.
        </div>
      </div>
    );
  }

  return (
    <div
      className="d-flex justify-content-end mt-5"
      style={{ marginLeft: "310px" }}
    >
      <div className="container mt-5">
        {/* Header with Download Button */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <button
            onClick={() => {
              navigate(-1);
            }}
            className="btn download-pdf-btn"
            style={{
              backgroundColor: "#ff9c00",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "5px",
              fontWeight: "500",
            }}
          >
            {/* <i className="fas fa-download me-2"></i> */}
            Back
          </button>
          <div>
            <h1 className="page-title" style={{ color: "#ff9c00" }}>
              Immigration Application Form
            </h1>
            <p className="text-muted mb-0">
              Application ID: <strong>{fullFormData?._id || "N/A"}</strong>
            </p>
            <p className="text-muted mb-0">
              Status:{" "}
              <span
                className={`badge ${
                  fullFormData?.isFinallySubmittedForm
                    ? "bg-success"
                    : "bg-warning"
                }`}
              >
                {fullFormData?.isFinallySubmittedForm ? "Submitted" : "Draft"}
              </span>
            </p>
          </div>

          <button
            onClick={downloadPDF}
            className="btn download-pdf-btn"
            style={{
              backgroundColor: "#ff9c00",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "5px",
              fontWeight: "500",
            }}
          >
            <i className="fas fa-download me-2"></i>
            Download PDF
          </button>
        </div>

        {/* Main Content */}
        <div className="row">
          {/* Primary Applicant Information */}
          <div className="col-md-6 mb-4">
            <div className="card shadow-sm">
              <div
                className="card-header"
                style={{ backgroundColor: "#ff9c00", color: "white" }}
              >
                <h5 className="mb-0">
                  <i className="fas fa-user me-2"></i>
                  Primary Applicant Information
                </h5>
              </div>
              <div className="card-body">
                <div className="info-grid">
                  <div className="info-item">
                    <span className="label">Full Name:</span>
                    <span className="value">
                      {fullFormData?.firstName || "N/A"}{" "}
                      {fullFormData?.middleName || ""}{" "}
                      {fullFormData?.lastName || ""}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Date of Birth:</span>
                    <span className="value">
                      {formatDate(fullFormData?.dateOfBirth)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Gender:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.gender)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Email:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.emailId)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Telephone:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.telephoneNo)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Passport No:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.passportNo)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Country of Citizenship:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.countryOfCitizenship)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Country of Birth:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.countryOfBirth)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">City of Birth:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.cityOfBirth)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Marital Status:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.maritalStatus)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">NOC Code:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.NOCcode)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">EE Profile No:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.EEno)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">UCI No:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.UCIno)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">CSQ:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.CSQ)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">CSQ Remarks:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.CSQRemarks)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">UNHCR:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.UNHCR)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">UNHCR Remarks:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.UNHCRRemarks)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Native Language:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.nativeLanguage)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Other Name:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.otherName)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Status in Canada:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.statusInCanada)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Place Entered in Canada:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.placeOfEnteredInCanada)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">First Time Entered:</span>
                    <span className="value">
                      {formatDate(fullFormData?.firstTimeEnteredInCanada)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Last Time Entered:</span>
                    <span className="value">
                      {formatDate(fullFormData?.lastTimeEnteredInCanada)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Address and Additional Information */}
          <div className="col-md-6 mb-4">
            <div className="card shadow-sm">
              <div
                className="card-header"
                style={{ backgroundColor: "#ff9c00", color: "white" }}
              >
                <h5 className="mb-0">
                  <i className="fas fa-address-card me-2"></i>
                  Address & Additional Information
                </h5>
              </div>
              <div className="card-body">
                <div className="info-grid">
                  <div className="info-item">
                    <span className="label">Mailing Address:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.mailingAddress)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Permanent Address:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.permanentAddress)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">City/Province of Residence:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.cityOrProvinceOfResidence)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Current Country of Residence:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.currentCountryOfResidence)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Province Considering Living:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.provinceOfConsiderLiving)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Money to Bring to Canada:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.moneyBroughtToCanada)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Total Family Members:</span>
                    <span className="value">
                      {formatResponse(
                        fullFormData?.totalFamilyMemberIncludingSpouseAndChild,
                      )}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Spouse Count:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.spouseCount)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Child Count:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.childCount)}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">
                      Applied to Express Entry Before:
                    </span>
                    <span className="value">
                      {formatResponse(
                        fullFormData?.didAppliedToExpressEntryCanadaBefore,
                      )}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">
                      Received Nomination Certificate:
                    </span>
                    <span className="value">
                      {formatResponse(
                        fullFormData?.receivedNominationCertificateFromProvinceOrTerritory,
                      )}
                    </span>
                  </div>
                  <div className="info-item">
                    <span className="label">Relation:</span>
                    <span className="value">
                      {formatResponse(fullFormData?.relation)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Primary Applicant Employment Status */}
          <div className="col-12 mb-4">
            <div className="card shadow-sm">
              <div
                className="card-header"
                style={{ backgroundColor: "#ff9c00", color: "white" }}
              >
                <h5 className="mb-0">
                  <i className="fas fa-briefcase me-2"></i>
                  Primary Applicant Employment Status
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="info-item">
                      <span className="label">Working Legally in Canada:</span>
                      <span className="value">
                        {formatResponse(fullFormData?.workingLegallyInCanada)}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="info-item">
                      <span className="label">
                        Primary Occupation/NOC Code:
                      </span>
                      <span className="value">
                        {formatResponse(
                          fullFormData?.primaryOccupationOrNOCcode,
                        )}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="info-item">
                      <span className="label">Has Job Offer/LMIA:</span>
                      <span className="value">
                        {formatResponse(
                          fullFormData?.havingAnyJOBOFFERorLMIAInCanada,
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Relatives in Canada */}
          {fullFormData?.relativesInCanada === "Yes" && (
            <div className="col-12 mb-4">
              <div className="card shadow-sm">
                <div
                  className="card-header"
                  style={{ backgroundColor: "#ff9c00", color: "white" }}
                >
                  <h5 className="mb-0">
                    <i className="fas fa-users me-2"></i>
                    Relatives in Canada
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="info-item">
                        <span className="label">Has Relatives in Canada:</span>
                        <span className="value">
                          {formatResponse(fullFormData?.relativesInCanada)}
                        </span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="info-item">
                        <span className="label">Resident Status:</span>
                        <span className="value">
                          {formatResponse(
                            fullFormData?.relativesInCanadaResidentWith,
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Primary Applicant Education History */}
          {renderEducationHistory(
            fullFormData?.educationHistory,
            "Primary Applicant",
          )}

          {/* Primary Applicant Language Test */}
          {renderLanguageTest(fullFormData, "Primary Applicant")}

          {/* Primary Applicant ECA */}
          {renderECA(fullFormData, "Primary Applicant")}

          {/* Primary Applicant Work History */}
          {renderWorkHistory(fullFormData?.workHistory, "Primary Applicant")}

          {/* Primary Applicant Declarations */}
          {renderDeclarations(fullFormData, "Primary Applicant")}

          {/* Spouse Information - Conditionally Rendered */}
          {fullFormData?.PrimaryApplicantSpouseData && (
            <>
              <div className="col-12 mb-4">
                <div className="card shadow-sm">
                  <div
                    className="card-header"
                    style={{ backgroundColor: "#ff9c00", color: "white" }}
                  >
                    <h5 className="mb-0">
                      <i className="fas fa-users me-2"></i>
                      Spouse Information
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="info-grid">
                          <div className="info-item">
                            <span className="label">Full Name:</span>
                            <span className="value">
                              {fullFormData?.PrimaryApplicantSpouseData
                                .firstName || "N/A"}{" "}
                              {fullFormData?.PrimaryApplicantSpouseData
                                .middleName || ""}{" "}
                              {fullFormData?.PrimaryApplicantSpouseData
                                .lastName || ""}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">Date of Birth:</span>
                            <span className="value">
                              {formatDate(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.dateOfBirth,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">Gender:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData.gender,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">Email:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.emailId,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">Telephone:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.telephoneNo,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">Passport No:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.passportNo,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">
                              Country of Citizenship:
                            </span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.countryOfCitizenship,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">Country of Birth:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.countryOfBirth,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">City of Birth:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.cityOfBirth,
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="info-grid">
                          <div className="info-item">
                            <span className="label">Date of Marriage:</span>
                            <span className="value">
                              {formatDate(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.dateOfMarriage,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">NOC Code:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.NOCcode,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">EE Profile No:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData?.EEno,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">UCI No:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData?.UCIno,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">CSQ:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData?.CSQ,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">CSQ Remarks:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.CSQRemarks,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">UNHCR:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData?.UNHCR,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">UNHCR Remarks:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.UNHCRRemarks,
                              )}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="label">Status in Canada:</span>
                            <span className="value">
                              {formatResponse(
                                fullFormData?.PrimaryApplicantSpouseData
                                  ?.statusInCanada,
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Spouse Employment Status */}
              <div className="col-12 mb-4">
                <div className="card shadow-sm">
                  <div
                    className="card-header"
                    style={{ backgroundColor: "#ff9c00", color: "white" }}
                  >
                    <h5 className="mb-0">
                      <i className="fas fa-briefcase me-2"></i>
                      Spouse Employment Status
                    </h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-4">
                        <div className="info-item">
                          <span className="label">
                            Working Legally in Canada:
                          </span>
                          <span className="value">
                            {formatResponse(
                              fullFormData?.PrimaryApplicantSpouseData
                                ?.workingLegallyInCanada,
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="info-item">
                          <span className="label">
                            Primary Occupation/NOC Code:
                          </span>
                          <span className="value">
                            {formatResponse(
                              fullFormData?.PrimaryApplicantSpouseData
                                ?.primaryOccupationOrNOCcode,
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="info-item">
                          <span className="label">Has Job Offer/LMIA:</span>
                          <span className="value">
                            {formatResponse(
                              fullFormData?.PrimaryApplicantSpouseData
                                ?.havingAnyJOBOFFERorLMIAInCanada,
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Spouse Education History */}
              {renderEducationHistory(
                fullFormData?.PrimaryApplicantSpouseData?.educationHistory,
                "Spouse",
              )}

              {/* Spouse Language Test */}
              {renderLanguageTest(
                fullFormData?.PrimaryApplicantSpouseData,
                "Spouse",
              )}

              {/* Spouse ECA */}
              {renderECA(fullFormData?.PrimaryApplicantSpouseData, "Spouse")}

              {/* Spouse Work History */}
              {renderWorkHistory(
                fullFormData?.PrimaryApplicantSpouseData?.workHistory,
                "Spouse",
              )}

              {/* Spouse Declarations */}
              {renderDeclarations(
                fullFormData?.PrimaryApplicantSpouseData,
                "Spouse",
              )}
            </>
          )}

          {/* Children Information - Conditionally Rendered */}
          {fullFormData?.PrimaryApplicantChildData &&
            fullFormData?.PrimaryApplicantChildData.length > 0 &&
            fullFormData?.PrimaryApplicantChildData.map((child, index) => (
              <React.Fragment key={child._id || index}>
                <div className="col-12 mb-4">
                  <div className="card shadow-sm">
                    <div
                      className="card-header"
                      style={{
                        backgroundColor: "#ff9c00",
                        color: "white",
                      }}
                    >
                      <h5 className="mb-0">
                        <i className="fas fa-child me-2"></i>
                        Child {index + 1} Information
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="info-grid">
                            <div className="info-item">
                              <span className="label">Name:</span>
                              <span className="value">
                                {child?.firstName || "N/A"}{" "}
                                {child?.middleName || ""}{" "}
                                {child?.lastName || ""}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">Date of Birth:</span>
                              <span className="value">
                                {formatDate(child?.dateOfBirth)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">Gender:</span>
                              <span className="value">
                                {formatResponse(child?.gender)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">Email:</span>
                              <span className="value">
                                {formatResponse(child?.emailId)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">Telephone:</span>
                              <span className="value">
                                {formatResponse(child?.telephoneNo)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">Passport No:</span>
                              <span className="value">
                                {formatResponse(child?.passportNo)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">
                                Country of Citizenship:
                              </span>
                              <span className="value">
                                {formatResponse(child?.countryOfCitizenship)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">Country of Birth:</span>
                              <span className="value">
                                {formatResponse(child?.countryOfBirth)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">City of Birth:</span>
                              <span className="value">
                                {formatResponse(child?.cityOfBirth)}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="info-grid">
                            <div className="info-item">
                              <span className="label">CSQ:</span>
                              <span className="value">
                                {formatResponse(child?.CSQ)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">CSQ Remarks:</span>
                              <span className="value">
                                {formatResponse(child?.CSQRemarks)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">UNHCR:</span>
                              <span className="value">
                                {formatResponse(child?.UNHCR)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">UNHCR Remarks:</span>
                              <span className="value">
                                {formatResponse(child?.UNHCRRemarks)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">EE Profile No:</span>
                              <span className="value">
                                {formatResponse(child?.EEno)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">UCI No:</span>
                              <span className="value">
                                {formatResponse(child?.UCIno)}
                              </span>
                            </div>
                            <div className="info-item">
                              <span className="label">Relation:</span>
                              <span className="value">
                                {formatResponse(child?.relation)}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Child Declarations */}
                {renderDeclarations(child, `Child ${index + 1}`)}
              </React.Fragment>
            ))}

          {/* Submission Info */}
          <div className="col-12">
            <div className="card shadow-sm">
              <div
                className="card-header"
                style={{ backgroundColor: "#ff9c00", color: "white" }}
              >
                <h5 className="mb-0">
                  <i className="fas fa-info-circle me-2"></i>
                  Submission Information
                </h5>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-4">
                    <div className="info-item">
                      <span className="label">Created At:</span>
                      <span className="value">
                        {formatDate(fullFormData?.createdAt)}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="info-item">
                      <span className="label">User ID:</span>
                      <span className="value">
                        {fullFormData?.userId || "N/A"}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="info-item">
                      <span className="label">Status:</span>
                      <span className="value badge bg-success">
                        {fullFormData?.isFinallySubmittedForm
                          ? "Submitted"
                          : "Draft"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImmigrationFormView;
